module.exports = __webpack_public_path__ + "img/hero-sns_fwt21.7c6f884.jpg";